import { Api } from "../config/request";
import qs from "qs";

export default {
    getPlatformFeeDetails(params) {
        let safe_params = ensure_safe_params(params)
        return Api.get(`/platform_fee?${qs.stringify(safe_params)}`);
    },
};

function ensure_safe_params(params) {
    const driverId = params["driver_id"];
    if (isNaN(driverId)) {
        params["driver_id"] = driverId.substring(2) - 10000;
    }
    params["driver_id"] = Number(params["driver_id"]);
    return params;
}